import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import { buildCloudinaryUrlMap } from './listingGalleryImages';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix } = props;
  const images = listing.images;
  const {title} = listing.attributes;
  const { listingImages, category } = listing.attributes.publicData || {};
  const cloudinaryImagesIds = listingImages?.length ? listingImages.map(img => img.public_id) : null;

  // Map Sharetribe image UUID → rendered variant dimensions, so <img> layout
  // hints match the served variant rather than the raw upload resolution.
  const variantDimensions = Array.isArray(images)
    ? images.reduce((acc, img) => {
        const uuid = img?.id?.uuid;
        const variant = img?.attributes?.variants?.['scaled-medium']
          || img?.attributes?.variants?.['scaled-small'];
        if (uuid && variant?.width && variant?.height) {
          acc[uuid] = { width: variant.width, height: variant.height };
        }
        return acc;
      }, {})
    : {};

  // Build lookup map: public_id → seoTags
  // public_id equals the Sharetribe UUID — same value in both systems
  const imageSeoTags = listingImages?.length
    ? listingImages.reduce((acc, img) => {
        if (img.public_id) {
          const dims = img.sharetribeImgId
            ? variantDimensions[img.sharetribeImgId] || {}
            : {};
          acc[img.public_id] = {
            seoTags: img.seoTags || null,
            width:   dims.width  || null,
            height:  dims.height || null,
          };
        }
        return acc;
      }, {})
    : {};

  // Sharetribe UUID → Cloudinary secure_url. Shared with the LCP preload in
  // ListingPageCarousel via listingGalleryImages.js so both resolve the same slide to the
  // same original; see that module for why keeping them together matters.
  const cloudinaryUrls = buildCloudinaryUrlMap(listingImages);

  const imageVariants = ['scaled-small', 'scaled-medium'];
  const thumbnailVariants = [variantPrefix];
  return (
    <div className={css.productGallery} data-testid="carousel" role="region" aria-label="Image gallery">
      <ListingImageGallery
          images={images}
          imageVariants={imageVariants}
          thumbnailVariants={thumbnailVariants}
          cloudinaryImagesIds={cloudinaryImagesIds}
          cloudinaryUrls={cloudinaryUrls}
          title={title}
          category={category}
          imageSeoTags={imageSeoTags}
        />
    </div>
  );
};

export default SectionGallery;
